import * as actionTypes from "../actions/actionTypes";
import { HeaderSearchFormState } from "./types";

const initState: HeaderSearchFormState = {
  shouldMinimizeSearchForm: false,
};

const reducer = (
  state: HeaderSearchFormState = initState,
  action
): HeaderSearchFormState => {
  switch (action.type) {
    case actionTypes.SET_SHOULD_MINIMIZE_SEARCH_FORM:
      return { ...state, shouldMinimizeSearchForm: action.data };

    default:
      return state;
  }
};

export default reducer;
